import type { OnboardingStep } from "types/auth";

/**
 * Determines whether the ForYou/Playlist navigator should be visible.
 * Hidden during account gates, and during setup_pending when there's no playlist
 * queue to show.
 */
export function shouldShowNavigator(
  onboardingStep: OnboardingStep | undefined,
  hasPlaylistQueueItems: boolean,
): boolean {
  if (onboardingStep === "email_verification_pending") {
    return false;
  }

  if (onboardingStep === "setup_pending" && !hasPlaylistQueueItems) {
    return false;
  }
  return true;
}
